import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'signin-field_change-keyboard_input';
/**
 * capture field name change
 */
export function trackSigninFieldChangeKeyboardInput(field_name_string, value_string2, sign_in_viewstring3) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { field_name_string, value_string2, sign_in_viewstring3 },
    });
}
